<template>
  <div class="consulting-wrapper">
    <div class="chat-nav">
      <div class="chat-nav-item">
        <router-link class="nav-link" active-class="active" to="chat" replace>线上复诊</router-link>
      </div>
      <div class="chat-nav-item">
        <router-link class="nav-link" active-class="active" to="record" replace v-if="info.is_bind == 1">TA的病历</router-link>
        <span class="unbind-link" v-else>TA的病历</span>
      </div>
    </div>
    <router-view />
  </div>
</template>

<style lang="less" scoped>
  .consulting-wrapper{
    width: 100%;
    min-height: 100%;
    .chat-nav{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 44px;
      border-bottom: 1px solid #EEE;
      background: #FFF;
      display: flex;
      justify-content: space-around;
      align-items: center;
      z-index: 100;
      .chat-nav-item{
        position: relative;
        height: 100%;
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        .nav-link{
          position: relative;
          height: 100%;
          line-height: 44px;
          font-size: 14px;
          color: #666;
          font-weight: bold;
          &::after{
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 3px;
            background: transparent;
            border-radius: 3px;
          }
          &.active{
            color: @xile;
            &::after{
              background: @xile;
            }
          }
        }
        .unbind-link{
          position: relative;
          height: 100%;
          line-height: 44px;
          font-size: 14px;
          color: #CCC;
          font-weight: bold;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        targetId: this.$route.params.id,
        info: {}
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      this.$root.post('/getChatUserInfo', {
        pat_id: this.targetId,
        doc_id: this.userInfo.user_id,
        type: 1,
      }).then(data => {
        this.info = data;
        console.log(data);
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ConsultingRoom/index.vue